const ZIPCODE_RANGES = [{
    province: "SP",
    from: 1e6,
    to: 19999999
}, {
    province: "RJ",
    from: 2e7,
    to: 28999999
}, {
    province: "ES",
    from: 29e6,
    to: 29999999
}, {
    province: "MG",
    from: 3e7,
    to: 39999999
}, {
    province: "BA",
    from: 4e7,
    to: 48999999
}, {
    province: "SE",
    from: 49e6,
    to: 49999999
}, {
    province: "PE",
    from: 5e7,
    to: 56999999
}, {
    province: "AL",
    from: 57e6,
    to: 57999999
}, {
    province: "PB",
    from: 58e6,
    to: 58999999
}, {
    province: "RN",
    from: 59e6,
    to: 59999999
}, {
    province: "CE",
    from: 6e7,
    to: 63999999
}, {
    province: "PI",
    from: 64e6,
    to: 64999999
}, {
    province: "MA",
    from: 65e6,
    to: 65999999
}, {
    province: "PA",
    from: 66e6,
    to: 68899999
}, {
    province: "AP",
    from: 689e5,
    to: 68999999
}, {
    province: "AM",
    from: 69e6,
    to: 69299999
}, {
    province: "RR",
    from: 693e5,
    to: 69399999
}, {
    province: "AM",
    from: 694e5,
    to: 69899999
}, {
    province: "AC",
    from: 699e5,
    to: 69999999
}, {
    province: "DF",
    from: 7e7,
    to: 72799999
}, {
    province: "GO",
    from: 728e5,
    to: 72999999
}, {
    province: "DF",
    from: 73e6,
    to: 73699999
}, {
    province: "GO",
    from: 737e5,
    to: 76799999
}, {
    province: "RO",
    from: 768e5,
    to: 76999999
}, {
    province: "TO",
    from: 77e6,
    to: 77999999
}, {
    province: "MT",
    from: 78e6,
    to: 78899999
}, {
    province: "MS",
    from: 79e6,
    to: 79999999
}, {
    province: "PR",
    from: 8e7,
    to: 87999999
}, {
    province: "SC",
    from: 88e6,
    to: 89999999
}, {
    province: "RS",
    from: 9e7,
    to: 99999999
}];


class ShippingCalculator extends HTMLElement {
    constructor() {
        super(),
        this.header = this.querySelector(".shipping-calculator__header"),
        this.header.addEventListener("click", this.toggle.bind(this)),
        this.zipcodeInput = this.querySelector("#shipping-calculator-zipcode"),
        VMasker(this.zipcodeInput).maskPattern("99999-999"),
        this.calculateShippingBtn = this.querySelector(".shipping-calculator__calculate-button"),
        this.calculateShippingBtn.addEventListener("click", this.prepareShippingRates.bind(this)),
        this.ratesWrapper = this.querySelector(".shipping-calculator__result"),
        this.showAllRatesBtn = this.querySelector(".rates__show-all-button"),
        this.showAllRatesBtn.addEventListener("click", this.showAllRates.bind(this));
        const e = sessionStorage.getItem("plano-c:cart:shippingZip") || void 0;
        e && (sessionStorage.setItem("plano-c:checkout:shippingZip", e),
        this.zipcodeInput.value = e,
        this.prepareShippingRates({
            preventDefault: ()=>{}
        }),
        this.toggle())
    }
    toggle() {
        this.classList.toggle("shipping-calculator--open")
    }

        // Função para exibir a mensagem de erro
    showMessage(message) {
        // Encontre o elemento onde a mensagem será exibida
        let messageContainer = this.querySelector(".shipping-calculator__error-message");
    
        // Se o container de mensagem não existir, crie um
        if (!messageContainer) {
            messageContainer = document.createElement("div");
            messageContainer.classList.add("shipping-calculator__error-message");
            this.appendChild(messageContainer);
        }
    
        // Define o texto da mensagem de erro
        messageContainer.textContent = message;
    
        // Adiciona uma classe para estilização (caso queira usar CSS para modificar a aparência)
        messageContainer.classList.add("error-message-visible");
    
        // Opcional: remover a mensagem após alguns segundos
        setTimeout(() => {
            this.removeShowMessage();
        }, 10000); // Remove a mensagem após 5 segundos
    }

        // Função para remover a mensagem de erro
    removeShowMessage() {
        const messageContainer = this.querySelector(".shipping-calculator__error-message");
        if (messageContainer) {
            messageContainer.remove();
        }
    }
    
    prepareShippingRates(e) {
        e.preventDefault();
        
        // Remove o texto do botão e adiciona o loader
        this.calculateShippingBtn.innerHTML = '<span class="loader"></span>';
    
        const t = this.zipcodeInput.value;
        sessionStorage.setItem("plano-c:cart:shippingZip", t),
        sessionStorage.setItem("plano-c:checkout:shippingZip", t);
        const r = `shipping_address[zip]=${t}&shipping_address[country]=Brazil&shipping_address[province]=${this.provinceByZip(t)}`;
        fetch(`/cart/prepare_shipping_rates.json?${r}`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((e=>{
            this.calculateShipping(r)
        }
        )).catch((e=>{
            this.showMessage("Adicione o produto ao carrinho para calcular!");
            console.error(e);
    
            // Restaura o texto do botão em caso de erro
            this.calculateShippingBtn.innerHTML = 'Calcular Frete';
        }
        ))
    }
    
    calculateShipping(e) {
        fetch(`/cart/async_shipping_rates.json?${e}`, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((e=>e.json())).then((t=>{
            if (t) {
                this.clearRates();
                this.querySelector(".shipping-calculator__result__rates").innerHTML = this.getRatesHTML(t.shipping_rates);
                this.ratesWrapper.style.display = "block";
            } else {
                setTimeout(()=>{
                    this.calculateShipping(e)
                }, 500);
            }
    
            // Restaura o texto do botão após o sucesso
            this.calculateShippingBtn.innerHTML = 'Calcular Frete';
        }
        )).catch((e=>{
            this.showMessage("Adicione o produto ao carrinho para calcular!");
            console.error(e);
    
            // Restaura o texto do botão em caso de erro
            this.calculateShippingBtn.innerHTML = 'Calcular Frete';
        }
        ))
    }
    clearRates() {
        this.removeShowMessage();
        this.ratesWrapper.classList.remove("show-all-rates"),
        this.showAllRatesBtn.classList.remove("hidden"),
        this.querySelector(".shipping-calculator__result__rates").innerHTML = ""
    }
    getRatesHTML(e) {
        return e.map((e=>{
            let t = null
              , r = null
              , i = null;
            e.delivery_range && e.delivery_range.length > 0 && (t = e.delivery_range.length > 1 ? e.delivery_range[1] : e.delivery_range[0],
            r = t.split("-")[2],
            i = t.split("-")[1]);
            const s = 100 * parseFloat(e.price);
            return `\n          <div class="shipping-calculator__result-item">\n            <p class="rate-name">${e.name}${t ? ` | Entrega até dia ${r}/${i}` : ""}</p>\n            <p class="rate-price">${s > 0 ? this.formatMoney(s) : "GRÁTIS"}</p>\n          </div>\n        `
        }
        )).join("")
    }
    formatMoney(e) {
        return `R$ ${(e / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    }
    provinceByZip(e) {
        const t = parseInt(e.replace("-", ""))
          , r = ZIPCODE_RANGES.find((e=>e.from <= t && e.to >= t));
        return r ? r.province : "SP"
    }
    showAllRates(e) {
        e.preventDefault(),
        this.ratesWrapper.classList.add("show-all-rates"),
        this.showAllRatesBtn.classList.add("hidden")
    }
}
customElements.define("shipping-calculator", ShippingCalculator);